import React from "react";
import styled from "@emotion/styled";
import SellerCard from "@components/card/SellerCard";
import { EmptyText } from "@pages/saved/_components/index";
import { useApiRequest } from "@utils/ApiRequest";
import { useQuery } from "@tanstack/react-query";
import useUserInfoStore from "@store/useUserInfoStore";

const Container = styled.div({
  position: "relative",
  display: "flex",
  flexDirection: "column",
  gap: "2.4rem",
  padding: "4rem 2rem",
  height: "100vh",
});

const SavedSellerList = () => {
  const { getFollowingList } = useApiRequest();
  const { userInfo } = useUserInfoStore();

  const { data: followingList } = useQuery({
    queryKey: ["followingList"],
    queryFn: () => getFollowingList(userInfo?.id),
    enabled: !!userInfo?.id,
  });

  return (
    <Container>
      {followingList?.length === 0 && <EmptyText type="seller" />}

      {followingList?.map((seller: any) => (
        <SellerCard
          key={seller.id}
          id={seller.id}
          name={seller.nickname}
          src={seller.profile_image}
          follow={seller.is_followed}
        />
      ))}
    </Container>
  );
};

export default SavedSellerList;
